<template>
  <div class="bonus-page">
    <div class="amendments-container">
      <h1 style="margin-left: 20px;">Bonusprogramm</h1>
      <div style="margin-left: 10px;">
        <div class="filter-bar mt-2" style="display: flex; gap: 1rem;">
          <!-- Suche -->
          <vs-input
            class="search-input bonus-width"
            icon-after="search"
            placeholder="Suche nach Bonus"
            v-model="searchTerm"
            icon="search"
            icon-no-border
            label-placeholder="icon-no-border"
          />
          <!-- Kategorie Filter -->
          <vs-select
            v-model="filterCategory"
            placeholder="Kategorie wählen"
            style="width: 200px;margin-top: 16px;"
          >
            <vs-select-item value="" text="Alle Kategorien" />
            <vs-select-item
              v-for="cat in categories"
              :key="cat"
              :value="cat"
              :text="cat"
            />
          </vs-select>

          <!-- Status Filter -->
          <vs-select
            v-model="filterStatus"
            placeholder="Status wählen"
            style="width: 200px;margin-top: 16px;"
          >
            <vs-select-item value="" text="Alle Status" />
            <vs-select-item value="active" text="Aktiv" />
            <vs-select-item value="paused" text="Inaktiv" />
            <vs-select-item value="archived" text="Archiviert" />
          </vs-select>

          <!-- Organisations-Filter -->
          <vs-select
            class="org-select"
            v-model="filterOrganizations"
            placeholder="Organisation wählen"
            style="width: 250px; margin-top: 16px;"
          >
            <vs-select-item value="" text="Alle Organisationen" />

            <vs-select-item
              v-for="org in getOrganizations"
              :key="org.id"
              :value="org.id"
              :text="org.name"
            />
          </vs-select>
        </div>
        <div class="bonus-list-container">
          <div class="bonus-list">
            <div
              v-for="bonus in filteredBonuses"
              :key="bonus.id"
              class="bonus-card"
              @click="viewBonus(bonus)"
            >
              <!-- Bild links anzeigen -->
              <div class="bonus-image">
                <img :src="bonus.previewImage" alt="Bonus Logo" />
              </div>

              <div class="bonus-info">
                <h2>{{ bonus.headline_text }}</h2>
                <p>{{ bonus.discount_text }}</p>
              </div>

              <div class="bonus-meta">
                <span
                  v-html="formatPeriod(bonus.start_at, bonus.end_at)"
                ></span>
                <div class="category-status">
                  <span class="category">{{
                    Array.isArray(bonus.categories)
                      ? bonus.categories[0]
                      : bonus.categories
                  }}</span>
                  <span
                    :class="[
                      'status',
                      bonus.status ? bonus.status.toLowerCase() : '',
                    ]"
                  >
                    {{ getStatusLabel(bonus.status) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <vs-button
          class="new-bonus-button"
          @click="createBonus"
          color="primary"
          icon="add"
        >
          Bonus neu
        </vs-button>
      </div>

      <!-- Detail / Form Popup -->
      <bonus-detail-popup
        v-if="selectedBonusDetail || selectedBonusEdit"
        :showPopup.sync="showBonusPopup"
        :bonus="selectedBonusDetail || selectedBonusEdit"
        @edit-bonus="openEdit"
        @save-bonus="saveBonus"
        @delete-bonus="deleteBonus"
      />
    </div>
  </div>
</template>

<script>
import BonusDetailPopup from "@/components/bonus/BonusDetailPopup.vue";
import { mapGetters } from "vuex";

export default {
  components: { BonusDetailPopup },
  data() {
    return {
      showBonusPopup: false,
      selectedBonusDetail: null,
      selectedBonusEdit: null,
      categories: [
        "Shopping",
        "Kultur",
        "Mobilität",
        "Multimedia",
        "Gesundheit",
        "Einrichtung",
        "Gastronomie",
        "Dienstleistung",
        "Sonstiges",
      ],
      filterCategory: "",
      filterOrganizations: [],
      filterStatus: "",
      searchTerm: "",
      statusMap: {
        archived: "Archiviert",
        paused: "Inaktiv",
        active: "Aktiv",
      },
    };
  },
  computed: {
    ...mapGetters("bonus", ["getBonuses"]),
    ...mapGetters("organization", ["getOrganizations"]),
    filteredBonuses() {
      let list = this.getBonuses || [];

      // Suche
      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        list = list.filter(
          (b) =>
            b.headline_text?.toLowerCase().includes(term) ||
            b.description_text?.toLowerCase().includes(term) ||
            b.address?.name?.toLowerCase().includes(term)
        );
      }

      // Kategorie-Filter
      if (this.filterCategory) {
        list = list.filter((b) => b.categories?.includes(this.filterCategory));
      }

      // Status-Filter
      if (this.filterStatus) {
        list = list.filter((b) => b.status === this.filterStatus);
      }
      //Org-Filter
      if (this.filterOrganizations.length > 0) {
        list = list.filter((b) =>
          b.organisations?.some((orgId) =>
            this.filterOrganizations.includes(String(orgId))
          )
        );
      } // Sortierung nach Startdatum (nächster oben)
      list.sort((a, b) => {
        const dateA = a.start_at ? new Date(a.start_at) : new Date(0);
        const dateB = b.start_at ? new Date(b.start_at) : new Date(0);
        return dateA - dateB; // aufsteigend
      });

      return list;
    },
  },
  created() {
    // Organisationen und Boni laden
    this.$store.dispatch("organization/loadOrganizations");
    this.$store.dispatch("bonus/loadBonuses");
  },
  methods: {
    formatPeriod(start, end) {
      if (!start || !end) return "";

      const format = (dateString) => {
        const [datePart, timePart] = dateString.split("T");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hours, minutes] = timePart
          ? timePart.split(":").map(Number)
          : [0, 0];

        const dayStr = ("0" + day).slice(-2);
        const monthStr = ("0" + month).slice(-2);
        const yearStr = year;
        const hoursStr = ("0" + hours).slice(-2);
        const minutesStr = ("0" + minutes).slice(-2);

        return `${dayStr}.${monthStr}.${yearStr}&nbsp;&nbsp; ${hoursStr}:${minutesStr} Uhr`;
      };

      return `${format(start)} - ${format(end)}`;
    },
    createBonus() {
      this.showBonusPopup = true;
      this.selectedBonusEdit = {
        id: null,
        categories: [],
        organizations: [],
        status: "Inaktiv",
        headline_text: "",
        description_text: "",
        code: "",
        name1: "",
        name2: "",
        street: "",
        zipCity: "",
        phone: "",
        email: "",
        website: "",
        shop_url: "",
        start_at: "",
        end_at: "",
        image_id: null,
      };
      this.selectedBonusDetail = null;
    },

    viewBonus(bonus) {
      this.selectedBonusDetail = { ...bonus };
      this.selectedBonusEdit = null;
      this.showBonusPopup = true;
    },

    openEdit(bonus) {
      this.selectedBonusDetail = null;
      this.selectedBonusEdit = { ...bonus };
    },

    closeEdit() {
      this.selectedBonusEdit = null;
      this.selectedBonusDetail = null;
      this.showBonusPopup = false;
    },

    saveBonus(bonus) {
      const saved = { ...bonus };

      if (saved.image instanceof File) {
        const reader = new FileReader();
        reader.onload = (e) => {
          saved.previewImage = e.target.result; // ✅ hier hinzufügen
          this.pushBonus(saved);
        };
        reader.readAsDataURL(saved.image);
      } else {
        if (saved.image_id && !saved.previewImage) {
          // Falls du das Bild erst nachladen willst
          this.$store
            .dispatch("core/getImage64", saved.image_id)
            .then((base64) => {
              saved.previewImage = `data:image/png;base64,${base64}`;
              this.pushBonus(saved);
            });
        } else {
          this.pushBonus(saved);
        }
      }
    },
    getStatusLabel(status) {
      return this.statusMap[status] || status;
    },
    pushBonus(bonus) {
      const index = this.getBonuses.findIndex((b) => b.id === bonus.id);
      if (index !== -1) {
        this.$store.commit("bonus/setBonuses", [
          ...this.getBonuses.slice(0, index),
          bonus,
          ...this.getBonuses.slice(index + 1),
        ]);
      } else {
        bonus.id = this.getBonuses.length
          ? Math.max(...this.getBonuses.map((b) => b.id)) + 1
          : 1;
        this.$store.commit("bonus/setBonuses", [...this.getBonuses, bonus]);
      }
      this.closeEdit();
    },
    deleteBonus(id) {
      this.$store.commit(
        "bonus/setBonuses",
        this.getBonuses.filter((b) => b.id !== id)
      );
      this.closeEdit();
    },
  },
  watch: {
    filterCategory() {
      this.closeEdit();
    },
    filterStatus() {
      this.closeEdit();
    },
    filterOrganizations() {
      this.closeEdit();
    },
    searchTerm() {
      this.closeEdit();
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.bonus-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.bonus-list-container {
  height: 50vh; /* Höhe der Box, passt du nach Bedarf an */
  overflow-y: auto; /* Scrollbar, wenn Inhalt größer ist */
  border: 1px solid transparent; /* unsichtbarer Rahmen, optional */
}

.bonus-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.7rem;
  background-color: #f9fafb;
  border-radius: 10px;
  cursor: pointer;
  width: 90%;
}

.bonus-image img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
}

.bonus-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-left: 20px;
}

.bonus-info h2 {
  margin: 0;
  font-size: 1.2rem;
  text-align: left;
}

.bonus-info p {
  margin: 0;
  color: #4b5563;
  text-align: left;
}

.bonus-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
  font-size: 0.9rem;
  padding-right: 20px;
}

.status {
  padding: 0.2rem 0.6rem;
  border-radius: 16px;
  margin-top: 0.3rem;
  text-align: center;
}

.status.active {
  background-color: #d1fae5;
  color: #065f46;
}

.status.paused {
  background-color: #fee2e2;
  color: #991b1b;
}

.status.archived {
  background-color: #fef3c7;
  color: #78350f;
}

.new-bonus-button {
  height: 40px;
  width: 250px;
  margin-top: 20px;
  margin-left: 5px;
}

.category {
  background-color: #e0e7ff;
  padding: 0.2rem 0.6rem;
  border-radius: 16px;
  margin-top: 0.3rem;
  text-align: center;
}

.category-status {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
</style>
